import React, { useEffect, useState } from "react";
import Chatbox from "../layout/common/Chatbox";
import ContentBody from "../layout/ContentBody";
import Footer from "../layout/common/Footer";
import Header from "../layout/common/Header";
import NavHeader from "../layout/common/NavHeader";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import SidebarTest from "../layout/common/SidebarTest";

const Dashboard = () => {
  const nav = useNavigate();
  const [showChtBox, setShowChtBox] = useState(false);
  const [topStats, setTopStates] = useState({});
  const [latestReg, setLatestReg] = useState([]);
  const [regChart, setRegChart] = useState([]);
  useEffect(() => {
    // const user = localStorage.getItem("user");
    (async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}dashboard`,
          {
            credentials: "include",
          }
        );
        if (response.status !== 200) {
          nav("/");
          return;
        }
      } catch (error) {
        nav("/");
        return;
      }
      const data = await fetch(
        `${process.env.REACT_APP_API_URL}dashboard-stats`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
          },
        }
      );
      const response = await data.json();
      setTopStates(response);

      const data1 = await fetch(
        `${process.env.REACT_APP_API_URL}latest-registrations`
      );
      const latestRegistration = await data1.json();
      setLatestReg(latestRegistration.users);

      const data2 = await fetch(
        `${process.env.REACT_APP_API_URL}user-registration-page-visits-chart`
      );
      const registrationChart = await data2.json();
      setRegChart(registrationChart);
    })();
  }, [nav]);

  const chtBoxHandler = (e) => {
    setShowChtBox(!e);
  };

  const chatboxClose = (e) => {
    setShowChtBox(!e);
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Dashboard</title>
      </Helmet>
      <NavHeader />
      <Header onClick={chtBoxHandler} showChtBox={showChtBox} />
      <Chatbox showChtBox={showChtBox} chatboxClose={chatboxClose} />
      <SidebarTest />
      <ContentBody
        topStats={topStats}
        latestRegistration={latestReg}
        regChart={regChart}
      />
      <Footer />
    </React.Fragment>
  );
};

export default Dashboard;
